const Alert = ({ type = 'info', title, message, children }) => {
  const styles = {
    error: {
      backgroundColor: '#fee',
      border: '1px solid #fcc',
      color: '#c33',
    },
    warning: {
      backgroundColor: '#fff3cd',
      border: '1px solid #ffc107',
      color: '#856404',
    },
    success: {
      backgroundColor: '#d4edda',
      border: '1px solid #c3e6cb',
      color: '#155724',
    },
    info: {
      backgroundColor: '#d1ecf1',
      border: '1px solid #bee5eb',
      color: '#0c5460',
    },
  }

  const style = styles[type] || styles.info

  return (
    <div
      style={{
        padding: '1rem',
        borderRadius: '4px',
        marginBottom: '1rem',
        ...style,
      }}
    >
      {title && <strong>{title}</strong>}
      {message && <div>{message}</div>}
      {children}
    </div>
  )
}

export default Alert
